import './PatientInitWizardStep.css';
import { Container, Box, Typography, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import Grid from '@mui/material/Grid2';
import * as yup from 'yup';
import WizardStep from '../ui/WizardStep';
import InfoBox from '../ui/DaliaComponents';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

const PatientInitStepExclusion: WizardStep = ({ formik }) => {
  const { profile } = useSelector((state: RootState) => state.auth);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    const newExClusionCriteria = checked
      ? [...(formik.values.exclusionCriteria || []), name]
      : formik.values.exclusionCriteria?.filter((criteria: string) => criteria !== name);
    formik.setFieldValue('exclusionCriteria', newExClusionCriteria);
  };

  return (
    <Container>
      <InfoBox emoji="⚠️">Un patient ne peut être inclu dans l'étude que s'il remplit tous les critères d'inclusion et tous les critères d'exclusion</InfoBox>
      <Box sx={{ mt: 4 }}>
        <Grid container>
          <Grid size={12}>
            &#128073; Cochez si le patient respecte les critères suivants :
            <FormGroup sx={{ mt: 1 }}>
              {profile?.hospital?.study?.exclusionCriteria.map((criteria, index) => (
                <FormControlLabel
                  control={<Checkbox checked={formik.values.exclusionCriteria?.includes(criteria)} name={criteria} onChange={handleCheckboxChange} />}
                  key={`criteria-${index}`}
                  label={criteria}
                />
              ))}
            </FormGroup>
          </Grid>
          <Grid size={12} sx={{ mt: 2 }}>
            {!formik.isValid && formik.touched && (
              <Typography align="center" color="error">
                Tous les critères doivent etre cochés
              </Typography>
            )}
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};
PatientInitStepExclusion.label = "Critères d'exclusion";
PatientInitStepExclusion.initialValues = {
  exclusionCriteria: [],
};

// all inclusion criteria must be checked
PatientInitStepExclusion.validationSchema = (profile) => {
  const exclusionCriteriaOptions = profile?.hospital?.study?.exclusionCriteria || [];
  return yup.object().shape({
    exclusionCriteria: yup.array().min(exclusionCriteriaOptions.length, 'Tous les critères doivent être cochés'),
  });
};

export default PatientInitStepExclusion;